import React, { Component } from 'react';
import { Row } from 'antd';
import { connect } from 'react-redux';

import { queryBackMy } from '@api/incubator/back';
import DateCondition from '@comm/search/DateConditionSearch';
import { setBackInfo } from '@store/modules/back_info';
import TableBack from './TableBack';

class PageManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      if (backInfo.start && backInfo.limit) {
        this.current = backInfo.start;
        this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        };
      }
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.location.pathname,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getBackMy = params => {
    queryBackMy(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 15,
              current: this.current,
            },
          },
        });
      }
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getBackMy(params);
  };

  render() {
    const { dataSource } = this.state;
    const parentProps = {
      dataSource,
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <DateCondition onChange={this.handleSearch} {...this.searchCondition} />
        </Row>
        <div id="ant-small-table">
          <TableBack {...parentProps} {...this.props} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(PageManage);



// WEBPACK FOOTER //
// ./src/components/incubator/release/PageMine.js